import { history } from '../store/index';
import { store } from '../../NextApp';
import { generateQueryString } from "../../util/Api";

import {
  CREATE_SPARES_ISSUE_SUCCESS,
  FETCH_SPARES_ISSUE_SUCCESS,
  GET_ALL_UOM_SUCCESS,
  GET_JOB_CARD_IN_SPARES_ISSUE_SUCCESS,
  GET_LOCATION_IN_SPARES_ISSUE_SUCCESS,
  GET_QUANTITY_BY_SUB_LOCATION,
  GET_SPARES_ISSUE_SUCCESS,
  SAVE_SPARE_NAME_IN_SPARE_ISSUES,
  SAVE_SPARES_ISSUE_QUERY,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import { fetchError, fetchStart, fetchSuccess } from "./Common";
import { getUser } from "./Auth";
import { message } from "antd";
import { arrayToCSV, downloadCSV } from "../../util/methods";


export const getResourceSuccess = ({ data, count }) => {
  return {
    type: GET_SPARES_ISSUE_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_SPARES_ISSUE_QUERY,
    query
  };
};

export const createResourceSuccess = ({ data }) => {
  return {
    type: CREATE_SPARES_ISSUE_SUCCESS,
    data
  };
};

export const getQuantitySuccess = (data) => {
  return {
    type: GET_QUANTITY_BY_SUB_LOCATION,
    data
  }
}

export const fetchResourceSuccess = ({ data }) => {
  return {
    type: FETCH_SPARES_ISSUE_SUCCESS,
    data
  };
};

export const getLocationInSparesIssueSuccess = ({ data }) => {
  return {
    type: GET_LOCATION_IN_SPARES_ISSUE_SUCCESS,
    data,
  };
};

export const getAllUOMSuccess = ({ data }) => {
  return {
    type: GET_ALL_UOM_SUCCESS,
    data,
  };
};

export const getJobCardInSparesIssueSuccess = ({ data }) => {
  return {
    type: GET_JOB_CARD_IN_SPARES_ISSUE_SUCCESS,
    data,
  };
};

export const saveSpareNameInSpareIssues = (data) => {
  return {
    type: SAVE_SPARE_NAME_IN_SPARE_ISSUES,
    data,
  };
};

export const getAllUOM = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/unit-of-measurement/get-all`);
      dispatch(fetchSuccess());
      dispatch(getAllUOMSuccess(response));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const getLocationByQuery = (locationQuery) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/location?locationQuery=${locationQuery}`);
      dispatch(fetchSuccess());
      dispatch(getLocationInSparesIssueSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};

export const getJobCardData = (locationQuery) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/job-card/spare-issue?locationQuery=${locationQuery}`);
      dispatch(fetchSuccess());
      dispatch(getJobCardInSparesIssueSuccess(response));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log('Error****:', error.response.data.message);
    }
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { sparesIssue } = store.getState();
      const { query } = sparesIssue;
      const response = await axios.get(`/spares-issue?${generateQueryString(query)}`);

      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const { sparesIssue } = store.getState();
      const { query } = sparesIssue;
      const response = await axios.get(`/spares-issue/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const secCol = JSON.parse(columns);
      if (secCol.includes('location') && response.data && response.data.length) {
        filters['location'] = { field: 'location', type: 'String' }
        response.data.map(item => {
          if (item && item.jobCard && item.jobCard.location && item.jobCard.location.name) {
            item['location'] = item.jobCard.location.name;
          } else {
            item['location'] = '';
          }
        })
      }
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/spares-issue`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({ data: response.data }));
      history.push('/spares-issue');
      dispatch(getResource());
    } catch (error) {
      const errorMessage = error && error.response && error.response.data && error.response.data.message;
      message.error(errorMessage || 'Unable to create spare issue', 10);
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const getQuantity = (data) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/spare-part-transaction/getQuantity`, data);
      dispatch(fetchSuccess());
      dispatch(getQuantitySuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
}

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.put(`/spares-issue/${id}`, payload);
      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/spares-issue');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/spares-issue/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({ data: response.data }));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/spares-issue/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
